export const LOGO_URL =
  "/lasertime-logo.png";
export const BRAND = "LaserTime";
